var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head _row"},_vm._l((_vm.routeList),function(item,index){return _c('div',{key:index,class:[
      item.route == _vm.$route.path
        ? 'head_child_click'
        : item.hover
        ? 'head_child_hover'
        : 'head_child',
      'head_common',
    ],on:{"click":function($event){$event.stopPropagation();return _vm.mouseDown(item)},"mouseenter":function($event){return _vm.mouseEnter(item)},"mouseleave":function($event){return _vm.mouseLeave(item)}}},[_c('p',[_vm._v(_vm._s(_vm.$t(item.title)))]),(item.route != '/deviceList')?_c('i',{class:[
        'el-icon-close',
        '_col_center',
        item.route == _vm.showCloseRoute ? 'icon_down' : '_icon',
      ],on:{"mouseenter":function($event){return _vm.iconEnter(item)},"mouseleave":_vm.iconLeave,"click":function($event){$event.stopPropagation();return _vm.closeRoute(item, index)}}}):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }